import { z } from 'zod'
import { Model } from './architecture'

export const RatingValidation = z.object({
  value: z.number({ required_error: '[Rating] value is required' }).min(0).max(10),
})

export class Rating extends Model {
  static create({ value }: z.infer<typeof RatingValidation>) {
    RatingValidation.parse({ value })
    return new Rating(value, false)
  }

  static createOrEmpty({ value }: { value?: number | string }) {
    if (value === undefined) {
      return Rating.empty()
    }
    try {
      const rating = parseFloat(value.toString())
      return Rating.create({ value: rating })
    } catch {
      return Rating.empty()
    }
  }

  static empty() {
    return new Rating(0, true)
  }

  constructor(
    readonly value?: number,
    private readonly isEmpty?: boolean
  ) {
    super()
  }

  hasRating(): this is Rating & z.infer<typeof RatingValidation> {
    return !this.isEmpty
  }

  toJSON() {
    return { value: this.value }
  }
}
